export default __webpack_public_path__ + "static/media/Poppins-Regular.4603832f.woff";